import './ServiceRequestCreateBankMandate.css';
import BankMandateValidation from './BankMandateValidation/BankMandateValidation';
import ExistingMandate from './ExistingMandate/ExistingMandate';

import {
  getServiceRequestDetailsAction,
  pushViewAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import 'flatpickr/dist/themes/light.css';
import {replaceTranslations, serviceRequestPostCall} from '../../../utils/util';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Typography,
  useToastProvider,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const ServiceRequestCreateBankMandate = (props) => {
  const {t} = useTranslation();

  const [payloadData, setPayloadData] = React.useState(null);
  const [isValidAccountHolderName, setIsValidAccountHolderName] =
    React.useState(false);
  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const {enqueueToast} = useToastProvider();

  const formButtonControls = () => {
    return (
      <div className="buttonControls">
        <Button
          id="cancelButton"
          onClick={() => props.cancelButtonClick(null)}
          variant="secondary"
        >
          {t('CANCEL')}
        </Button>

        <Button
          type="submit"
          disabled={submitDisabled}
          id="bankMandatePrimaryBtn"
          variant="primary"
          startIcon={
            loader && <CircularProgress size="small" style={{color: '#000'}} />
          }
          onClick={() => {
            submitHandler();
          }}
        >
          {t('SUBMIT')}
        </Button>
      </div>
    );
  };
  const submitHandler = () => {
    setLoader(true);
    const reqBody = {...payloadData};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    if (props.contractNumber === 'ALL_CONTRACTS') {
      reqBody.allContracts = props.allContracts.contracts.map(
        (contract) => contract.contractNumber
      );
      reqBody.contractNumber = props.allContracts.contracts[0].contractNumber;
    }
    payloadData &&
      serviceRequestPostCall(
        {
          requestType: 'Bank Mandate',
          countryCode: props.country,
          contractNumber: props.contractNumber,
          userEmail: props.userDetails.email,
          isExistingAccountHolder: isValidAccountHolderName,
          ...reqBody,
        },
        enqueueToast,
        'CONTACT_CALLBACK_MODAL',
        () => {
          setLoader(false);
        },
        replaceTranslations(t('SERVICE_REQUEST_LIMIT'), 2, t('BANK_MANDATE')),
        t('SERVICE_REQUEST_SUCCESS'),
        t('SERVICE_REQUEST_CREATION_FAILED'),
        () => {
          appStore.dispatch(getServiceRequestDetailsAction(null));
          appStore.dispatch(pushViewAction('serviceRequestDashboard'));
        }
      );
  };

  const handleSubmitDisabled = (value, data) => {
    if (value) {
      setSubmitDisabled(true);
    } else {
      setPayloadData(data);
      setSubmitDisabled(false);
    }
  };
  let cardData = {
    Submitted_By: {
      label: t('SUBMITTED_BY'),
      value: props.userDetails.name,
    },
    Role: {
      label: t('ROLE_NAME'),
      value: t('ROLE_VALUE'),
    },
  };
  if (
    props.orgs[props.selectedOrg]?.name &&
    props.orgs[props.selectedOrg]?.name != ''
  ) {
    cardData.Company = {
      label: t('COMPANY'),
      value: props.orgs[props.selectedOrg]?.name,
    };
  }

  return (
    <div className={'ServiceRequestChangePhoneWrapper'}>
      <div className={'ServiceRequestCard'}>
        <div className="serviceRequestHeader">
          <div className={'title'}>{t('CHANGE_DD_MANDATE')}</div>
        </div>
        <div className={'subTitle'}>{t('CHANGE_DD_MANDATE_SUBTITLE')}</div>
      </div>
      <ExistingMandate contractNumber={props.contractNumber} />
      <Box pl={4} pr={4} pb={4}>
        <BankMandateValidation
          isSubmitDisabled={(value, data) => handleSubmitDisabled(value, data)}
          validAccountHolderName={setIsValidAccountHolderName}
        />
      </Box>
      <div className={'subTitle'}>{t('DEBIT_PAY_MSG')}</div>
      <Card className="mandate-note-card">
        <CardContent className="CardContentCustom">
          {cardData &&
            Object.keys(cardData).map((key, index) => {
              return (
                <FormControl
                  fullWidth
                  key={'card-view' + key}
                  id={`CardViewRow` + key}
                  className="CardContentBlock"
                >
                  <Typography variant="label" className={'mandate-label'}>
                    {cardData[key].label}
                  </Typography>
                  <Typography className={`mandate-value`}>
                    {cardData[key].value}
                  </Typography>
                </FormControl>
              );
            })}
        </CardContent>
      </Card>
      {formButtonControls()}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    userDetails: state.appStates.userDetailsInfo,
    selectedOrg: state.appStates.selectedOrg,
    orgs: state.appStates.allContracts.organisation,
  };
};

export default connect(mapStateToProps)(ServiceRequestCreateBankMandate);
